// ── Slider — ползунок ────────────────────────────────────────────────────────
// Обычный <input type="range"> (клавиши, экранный диктор — как у всех), но с
// тонкой полосой 4 px и кружком 16 px, а зона нажатия — 24 px мышью и 32 px
// пальцем (стили .ac-slider в index.css). label обязателен — это название для
// диктора, если рядом нет видимой подписи <label>.

import { usePalette } from './theme';

export default function Slider({ label, value, min = 0, max = 1, step = 'any', onChange, style, C: Cp, ...rest }) {
  const C = usePalette(Cp);
  return (
    <input type="range" className="ac-slider" aria-label={label} value={value} min={min} max={max} step={step} onChange={onChange}
      style={{ '--ac-track': C.border, '--ac-thumb': C.blue, flex: '1 1 auto', minWidth: 0, ...style }} {...rest} />
  );
}
